import { render, staticRenderFns } from "./TechnologyLocationEvidencesControl.vue?vue&type=template&id=f0bcb6b2&"
import script from "./TechnologyLocationEvidencesControl.vue?vue&type=script&lang=js&"
export * from "./TechnologyLocationEvidencesControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports